import React from "react";
export const TopBannerSlot = () => {
  return <div id="top-banner" className="top-banner"></div>;
};
